import {
  Box,
  Heading,
  Image,
  LinkBox,
  LinkOverlay,
  Text,
} from '@chakra-ui/react';
import formatDistance from 'date-fns/formatDistance';
import isValid from 'date-fns/isValid';

import { IBlogItem } from '../../models/blog-item';

export function BlogItem(item: IBlogItem) {
  return (
    <LinkBox as="article" p="5" borderWidth="1px" rounded="md">
      <Box
        height="500px"
        overflow="hidden"
        sx={{
          maskImage: 'linear-gradient(to bottom, black 50%, transparent 100%)',
        }}
      >
        {isValid(new Date(item.pubDate)) &&
          !Number.isNaN(new Date(item.pubDate).getTime()) && (
            <Text as="time" dateTime={item.pubDate}>
              {formatDistance(new Date(item.pubDate), new Date(), {
                addSuffix: true,
              })}
            </Text>
          )}

        <Heading size="md" my={2} noOfLines={1}>
          <LinkOverlay href={item.link} target="_blank">
            {item.title}
          </LinkOverlay>
        </Heading>

        <Image src={item.thumbnail} my={3} />

        <Text
          as="div"
          dangerouslySetInnerHTML={{ __html: item.description }}
        ></Text>
      </Box>
    </LinkBox>
  );
}
